import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  useClientApiV1DashboardsRecentLearningQuery,
} from '../../resources/@types/accountSchema';

interface UseClientV1DashboardsRecentLearningQuery {
  options?: Parameters<typeof useClientApiV1DashboardsRecentLearningQuery>[0]['options'];
}

export function useDashboardsRecentLearningQuery({
  options,
}: UseClientV1DashboardsRecentLearningQuery) {
  return useClientApiV1DashboardsRecentLearningQuery({
    queryKey: getDashboardsRecentLearningQueryKey(),
    url: API_ENDPOINT.CLIENT_V1_DASHBOARDS_RECENT_LEARNING,
    options,
  });
}

export const getDashboardsRecentLearningQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_DASHBOARDS_RECENT_LEARNING,
];
